import './loader.css'

const VideoChanelLoader = () => {

    return (
        <div className="video-chanel-loader-container">
            <div className="video-chanel-loader"></div>
        </div>
    )
}

export default VideoChanelLoader;